import { render, staticRenderFns } from "./CulturalModal.vue?vue&type=template&id=07e9b129&scoped=true"
import script from "./CulturalModal.vue?vue&type=script&lang=js"
export * from "./CulturalModal.vue?vue&type=script&lang=js"
import style0 from "./CulturalModal.vue?vue&type=style&index=0&id=07e9b129&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e9b129",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07e9b129')) {
      api.createRecord('07e9b129', component.options)
    } else {
      api.reload('07e9b129', component.options)
    }
    module.hot.accept("./CulturalModal.vue?vue&type=template&id=07e9b129&scoped=true", function () {
      api.rerender('07e9b129', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/SchemeCard/components/CulturalModal.vue"
export default component.exports